export const extraSmall = 'screen and (max-width: 320px)'
export const mobile = 'screen and (min-width: 350px)'
export const ipad = 'screen and (min-width: 760px)'
export const tablet = 'screen and (min-width: 1368px)'
export const mobileOnly = 'screen and (max-width: 1368px)'
